// extracted by mini-css-extract-plugin
export var root = "_866670b8ee684b4f8a92894dfa9a39d0-css";